import { useEffect, useState } from "react";
import { useAccount } from "wagmi";
import { Button } from "@/src/components";
import { ConnectButton } from "@/src/components/connectButton";
import { useStake } from "@/src/hooks/useStake";
import { toast } from "react-hot-toast";
import { activeChain } from "@/src/configs/chainConfig";
import { useVotes } from "@/src/hooks/useVotes";
import { fmt } from "@/src/lib/utils";

export const VoteCard = () => {
  const { chain } = useAccount();
  const { onVote } = useStake();
  const { isConnected } = useAccount();
  const { eligibleVotes, vote_enabled, supplyAmount, deadline } = useVotes();

  const [{ isCorrectChain }, setState] = useState({
    isCorrectChain: true,
  });

  useEffect(() => {
    if (isConnected)
      setState({
        isCorrectChain: chain?.id === Number(activeChain.chainId),
      });

  }, [chain, isConnected]);

  const voteYes = async (event) => {
    event.preventDefault();
      return toast.promise(onVote(1), {
        loading: "Transaction is in progress",
        success: "Successfully voted Yes",
        error: (data) => data,
      });
  };
  const voteNo = async (event) => {
    event.preventDefault();
      return toast.promise(onVote(0), {
        loading: "Transaction is in progress",
        success: "Successfully voted No",
        error: (data) => data,
      });
  };
  return (
    <div>
    <div className="border border-border max-w-xl mx-auto w-full rounded-xl p-4 sm:p-6 space-y-5">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">FRB Supply Increase Vote</h3>
        <span className={(vote_enabled && Date.now()/1000 < (parseInt(deadline))) ? "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-success/15 text-success" : "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-destructive/15 text-destructive"}>{(vote_enabled && Date.now()/1000 < (parseInt(deadline))) ? "Open" : "Closed"}</span>
      </div>

      {vote_enabled &&
      <div className="flex items-center justify-between py-2.5 border-b border-border/50">
        <span className="text-sm text-muted-foreground">Proposed Amount</span>
        <span className="text-lg sm:text-2xl font-bold text-foreground font-mono">{fmt(supplyAmount, 0)}</span>
      </div>}

      <div className="space-y-0">
        <div className="flex items-center justify-between py-2.5 border-b border-border/50">
          <span className="text-sm text-muted-foreground">Eligible votes</span>
          <span className="text-lg sm:text-2xl font-bold text-foreground font-mono">{parseInt(eligibleVotes)}</span>
        </div>
      </div>

        <div>
          {!isConnected && (
            <div className="flex justify-center">
              <ConnectButton />
            </div>
          )}
      </div>

      {isConnected && (
        <div className="grid grid-cols-2 gap-3 pt-2">
          <form onSubmit={voteYes}>
            <Button type="submit" value="1" disabled={!isCorrectChain ||eligibleVotes===0 || vote_enabled===false} className="bg-success/15 text-success border border-success/30 hover:bg-success/25 hover:shadow-none w-full">Yes</Button>
          </form>
          <form onSubmit={voteNo}>
            <Button type="submit" value="0" disabled={!isCorrectChain || eligibleVotes===0 || vote_enabled===false} className="bg-destructive/15 text-destructive border border-destructive/30 hover:bg-destructive/25 hover:shadow-none w-full">No</Button>
          </form>
        </div>
      )}

    </div>
    </div>
  );
};
